import type { CourseCategory } from "@brookbush/types";

import { queryTypes, useQueryState } from "next-usequerystate";
import useSWR, { type SWRResponse } from "swr";

import { constructQueryString } from "~/utils/helpers";

const useCourseCategories = () => {
	const [accreditationFilter] = useQueryState(
		"accreditation",
		queryTypes.string,
	);

	const queryString = constructQueryString([
		{
			key: "accreditation",
			value: accreditationFilter,
		},
	]);
	return useSWR(`/courses/categories${queryString}`) as SWRResponse<
		CourseCategory[]
	> & {
		data: CourseCategory[];
	};
};

export default useCourseCategories;
